import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

interface IQuizSubmissionPayload {
  choice_id: string;
  is_correct: boolean;
  quiz_id: string;
  article_content_id: string;
  assignment_content_id: string;
  quiz_question_id: string;
}

const useChecksForUnderstandingSubmit = () => {
  const submitChecksForUnderstandingPostRequest = useCallback(
    (payload: IQuizSubmissionPayload) => {
      const requestConfig = {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      };

      return new Request(
        `${API_BASE_URL}/api/v3/checks-for-understanding-quiz-submission/`,
        requestConfig,
      );
    },
    [],
  );
  return useRestMutation(submitChecksForUnderstandingPostRequest);
};

export default useChecksForUnderstandingSubmit;
